import React from "react";
import {
  SummarySection,
  SectionHeading,
  SectionBox,
  SourcesList,
  SourceItem,
  SourceTitle,
  SourceUrl,
} from "./SourcesSection.styles";
import { EmptyStateMessage } from "../InfoSection/InfoSection.styles";

export const SourcesSection = ({ sources, t }) => (
  <SummarySection>
    <SectionHeading>{t("logs.sources")}</SectionHeading>
    <SectionBox>
      {!sources || sources.length === 0 ? (
        <EmptyStateMessage>{t("logs.noSources")}</EmptyStateMessage>
      ) : (
        <SourcesList>
          {sources?.map((source, index) => (
            <SourceItem key={index}>
              <SourceTitle>{source.title}</SourceTitle>
              <SourceUrl
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {source.url}
              </SourceUrl>
            </SourceItem>
          ))}
        </SourcesList>
      )}
    </SectionBox>
  </SummarySection>
);
